var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5026 2.50065C6.36047 2.50065 3.0026 5.85851 3.0026 10.0007C3.0026 14.1428 6.36047 17.5006 10.5026 17.5006C14.6447 17.5006 18.0026 14.1428 18.0026 10.0007C18.0026 5.85851 14.6447 2.50065 10.5026 2.50065ZM1.33594 10.0007C1.33594 4.93804 5.43999 0.833984 10.5026 0.833984C15.5652 0.833984 19.6693 4.93804 19.6693 10.0007C19.6693 15.0633 15.5652 19.1673 10.5026 19.1673C5.43999 19.1673 1.33594 15.0633 1.33594 10.0007Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90814 6.07806C10.2336 5.75263 10.7612 5.75263 11.0867 6.07806L14.42 9.4114C14.7454 9.73683 14.7454 10.2645 14.42 10.5899L11.0867 13.9232C10.7612 14.2487 10.2336 14.2487 9.90814 13.9232C9.5827 13.5978 9.5827 13.0702 9.90814 12.7447L12.6522 10.0007L9.90814 7.25657C9.5827 6.93114 9.5827 6.4035 9.90814 6.07806Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33594 9.99935C6.33594 9.53911 6.70903 9.16602 7.16927 9.16602H13.8359C14.2962 9.16602 14.6693 9.53911 14.6693 9.99935C14.6693 10.4596 14.2962 10.8327 13.8359 10.8327H7.16927C6.70903 10.8327 6.33594 10.4596 6.33594 9.99935Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow-right-circle.a6db660b3660db4b769733635a6d14aa.svg";
export { ForwardRef as ReactComponent };